import { ReactNode } from "react";
import { Link } from "react-router-dom";
import {
  ESSAY_PRIZE_CLOSING_DATE,
  ESSAY_PRIZE_HEAR_BACK_DATE,
  type EssayPrizeCategory,
} from "./essayPrizes";

type EssayPrizeCardProps = {
  children: ReactNode;
  className?: string;
  id?: string;
};

export function EssayPrizeCard({ children, className, id }: EssayPrizeCardProps) {
  return (
    <article id={id} className={["nep-prize-card", className].filter(Boolean).join(" ")}>
      {children}
    </article>
  );
}

export function OverviewPrizeCard({ category }: { category: EssayPrizeCategory }) {
  return (
    <EssayPrizeCard className="nep-prize-card--overview">
      <div className="nep-prize-card__deadline-pills">
        <span className="nep-prize-card__deadline-pill">Closes {ESSAY_PRIZE_CLOSING_DATE}</span>
        <span className="nep-prize-card__deadline-pill nep-prize-card__deadline-pill--muted">
          Hear back by {ESSAY_PRIZE_HEAR_BACK_DATE}
        </span>
      </div>
      <div className="nep-prize-card__overview-head">
        <p className="nep-prize-card__amount">£500</p>
        <h3 className="nep-prize-card__title">{category.title}</h3>
        <p className="nep-prize-card__audience">{category.shortLabel}</p>
      </div>
      <p className="nep-prize-card__excerpt">&ldquo;{category.essayQuestion}&rdquo;</p>
      <Link to={category.path} className="nep-prize-card__link">
        View prize details →
      </Link>
    </EssayPrizeCard>
  );
}
